/** Query params passed to the Next calculator iframe (ClimatePlans embed pattern). */
export interface CalculatorEmbedLocation {
  location: string;
  geofips: string;
}

/** San Francisco city/place GEOID (mode 2). */
export const SAN_FRANCISCO_PLACE_GEOID = '0667000';

export const CCSF_CALCULATOR_EMBED_LOCATION: CalculatorEmbedLocation = {
  location: 'San Francisco, California',
  geofips: SAN_FRANCISCO_PLACE_GEOID
};

const SAN_FRANCISCO_COMPETITION_SLUGS = new Set(['ccsf', 'sf', 'sfenvironment']);

export const calculatorEmbedLocationForCompetition = (
  competitionName?: string
): CalculatorEmbedLocation | undefined => {
  const slug = String(competitionName || '').trim().toLowerCase();
  if (SAN_FRANCISCO_COMPETITION_SLUGS.has(slug)) {
    return CCSF_CALCULATOR_EMBED_LOCATION;
  }
  return undefined;
};
